import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoPatientsIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 140,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.1382 26.1623C69.7027 44.467 64.4613 58.2684 48.8132 66.5333C38.8632 71.7886 27.4076 75.6469 21.53 85.2424C0.121438 120.193 45.7558 148.941 75.1378 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.1382 26.1623Z",
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 89.6406,
			cy: 120.66,
			r: 6,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 40.6406,
			cy: 35.6602,
			r: 8,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97 73H121",
			stroke: "url(#paint0_linear_9434_32957)",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97 91H121",
			stroke: "url(#paint1_linear_9434_32957)",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M105 37C105 39.7614 102.761 42 100 42C97.2386 42 95 39.7614 95 37C95 34.2386 97.2386 32 100 32C102.761 32 105 34.2386 105 37Z",
			fill: "url(#paint2_linear_9434_32957)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.1382 26.1623C69.7027 44.467 64.4613 58.2684 48.8132 66.5333C38.8632 71.7886 27.4076 75.6469 21.53 85.2424C0.121438 120.193 45.7558 148.941 75.1378 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.1382 26.1623Z",
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 89.6406,
			cy: 120.66,
			r: 6,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 40.6406,
			cy: 35.6602,
			r: 8,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 100,
			cy: 48.3333,
			r: 17.3333,
			fill: "url(#paint3_linear_9434_32957)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M134.667 89.5C134.667 100.27 134.667 109 99.9999 109C65.3333 109 65.3333 100.27 65.3333 89.5C65.3333 78.7304 80.854 70 99.9999 70C119.146 70 134.667 78.7304 134.667 89.5Z",
			fill: "url(#paint4_linear_9434_32957)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M150.333 88.9998C150.333 96.3636 144.364 102.333 137 102.333C129.636 102.333 123.667 96.3636 123.667 88.9998C123.667 81.636 129.636 75.6665 137 75.6665C144.364 75.6665 150.333 81.636 150.333 88.9998Z",
			fill: "#DB5543",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M137 81.3335C137.552 81.3335 138 81.7812 138 82.3335V90.3335C138 90.8858 137.552 91.3335 137 91.3335C136.448 91.3335 136 90.8858 136 90.3335V82.3335C136 81.7812 136.448 81.3335 137 81.3335ZM137 93.3335C137.552 93.3335 138 93.7812 138 94.3335V95.6668C138 96.2191 137.552 96.6668 137 96.6668C136.448 96.6668 136 96.2191 136 95.6668V94.3335C136 93.7812 136.448 93.3335 137 93.3335Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_9434_32957",
				x1: 97,
				y1: 73.5,
				x2: 121,
				y2: 73.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4C1DC8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_9434_32957",
				x1: 97,
				y1: 91.5,
				x2: 121,
				y2: 91.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4C1DC8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_9434_32957",
				x1: 100,
				y1: 32,
				x2: 100,
				y2: 42,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_9434_32957",
				x1: 100,
				y1: 31,
				x2: 100,
				y2: 65.6667,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_9434_32957",
				x1: 99.9999,
				y1: 70,
				x2: 99.9999,
				y2: 109,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgNoPatientsIcon);
export { ForwardRef as ReactComponent };
